import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\about\\Bod.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\about\\ChairmanMessage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\AboutOverview.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\InnerBanner.jsx");
